/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
declare global {
  interface Window {
    AppleID?: AppleLoginAuth;
    AwsWafIntegration: {
      getToken: () => Promise<void>;
      hasToken: () => boolean;
    };
    FB?: {
      XFBML: {
        parse: () => void;
      };
      init: (_: unknown) => void;
    };
    __igEmbedLoaded?: () => void;
    _wct: {
      google_tracking_id: string;
      proxy: string;
      uid: string;
    };
    awsWafCookieDomainList: string[];
    braze?: {
      changeUser: Function;
      disableSDK: Function;
      enableSDK: Function;
      getFeatureFlag: (x: string) => { enabled: boolean } | undefined;
      initialize: Function;
      logCustomEvent: Function;
      logPurchase: Function;
      openSession: Function;
    };
    env: Env;
    fbAsyncInit?: () => void;
    fbq: Function;
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
    ttq: {
      track: Function;
    };
    twq: Function;
  }

  namespace NodeJS {
    interface ProcessEnv {
      BRAZE_API_KEY_DE: string;
      BRAZE_API_KEY_GB: string;
    }
  }
}

export type AppleLoginAuth = {
  auth: {
    signIn: () => Promise<{ authorization: { id_token: string } }>;
  };
};

export type LogLevel = 'info' | 'warning' | 'error';

export type Env = {
  ADYEN_ENV: 'live' | 'test';
  ADYEN_KEY: string;
  ALGOLIA_API_KEY: string;
  ALGOLIA_APP_ID: string;
  ALGOLIA_LEGACY_INDEX: string;
  ALGOLIA_PRODUCTS_INDEX: string;
  APPLE_CLIENT_ID: string;
  APPLE_STORE_URL: string;
  APP_NUM_OF_RATINGS: string;
  APP_RATING: string;
  APP_RATINGS_LAST_UPDATED: string;
  BRAZE_BASE_URL: string;
  BRAZE_SDK_API_KEY: string;
  COOKIES_DOMAIN: string;
  FACEBOOK_APP_ID: string;
  FACEBOOK_PIXEL_ID: string;
  FACEBOOK_PIXEL_TOKEN: string;
  FF_INTERNATIONAL_HEADERS: boolean;
  FF_INTERNATIONAL_HOMEPAGE: boolean;

  GA_TRACKING_ID: string;
  GOOGLE_LOGIN_CLIENT_ID: string;
  GTM_AUTH_DE: string;
  GTM_AUTH_GB: string;
  GTM_CONTAINER_ID_DE: string;
  GTM_CONTAINER_ID_GB: string;
  GTM_PREVIEW_DE: string;
  GTM_PREVIEW_GB: string;
  IS_PRODUCTION: boolean;
  LOG_LEVEL?: LogLevel;
  SENTRY_DSN: string;
  SITE_BASE_URL: string;
  SUB_DOMAIN?: string;
};

export type PAGE_POSITIONS =
  | 'Banner'
  | 'Body'
  | 'Cancel modal'
  | 'Confirm Modal'
  | 'Dynamic Product Block'
  | 'Featured Product Block'
  | 'Filter Toolbar'
  | 'Full Bleed Image'
  | 'Gating Card'
  | 'Header'
  | 'Homepage App Banner'
  | 'Homepage Article Highlight Carousel'
  | 'Homepage Article Duo'
  | 'Homepage Article Headlines'
  | 'Homepage Article Highlights'
  | 'Homepage Article Tiles'
  | 'Homepage Hot Deals'
  | 'Homepage Latest Feature'
  | 'Homepage Latest News'
  | 'Homepage Marketplace'
  | 'Homepage Popular Brands'
  | 'Homepage Splash'
  | 'Homepage Top Categories'
  | 'Homepage Top Silhouettes'
  | 'Homepage Upcoming Releases'
  | 'Homepage USPs'
  | 'Homepage Whats Hot'
  | 'Homepage'
  | 'Image Grid'
  | 'Image'
  | 'Lifestyle News Discover More'
  | 'Lifestyle News Small Product Card Grid'
  | 'Modal'
  | 'More Colours'
  | 'PDP Carousel'
  | 'PLP Direct Carousel'
  | 'PLP Main List'
  | 'PLP Mid Modules'
  | 'PLP Popular Carousel'
  | 'PLP Quick Buy'
  | 'PLP Recommendations'
  | 'PLP Top Modules'
  | 'Product Card'
  | 'Product Carousel'
  | 'Product Grid'
  | 'Profile Notifications'
  | 'Sale Page Splash'
  | 'Seller Selection'
  | 'Sign in modal'
  | 'Size Selection'
  | 'Social Media Carousel'
  | 'Sticky CTA'
  | 'Top Bar'
  | 'WTB'
  | `Sale Product List-${number}`
  | `Sale Products Highlight-${number}`;

export const REGISTRATION_INTERNAL_SOURCES: Record<string, string> = {
  default: '-',
  like: 'Wishlist',
  restock: 'Notify Me Modal'
};

export type Entrypoint = 'email' | 'search' | 'social' | 'unknown';

export type PdpContext = {
  pagePosition?: PAGE_POSITIONS;
  position?: number;
  previousPageType?: PageType;
};

export type PageType =
  | 'article'
  | 'homepage'
  | 'contact'
  | 'homepage'
  | 'news-article'
  | 'pdp'
  | 'plp'
  | 'sale'
  | 'search'
  | 'profile-notifications'
  | 'sales event generic' // Legacy react casing
  | 'single-affiliate-pdp'
  | 'sole-market-listing-selection'
  | 'sole-market-payment'
  | 'sole-market-pdp'
  | 'sole-market'
  | 'unknown';

export type Icon = {
  height: string;
  width: string;
};

export type ImageBleed = 'full' | 'left' | 'right' | 'none';

export enum OS {
  Android = 'android',
  Linux = 'linux',
  MacOS = 'macOS',
  Unknown = 'unknown',
  Windows = 'windows',
  iOS = 'ios'
}

export type LoginModalType =
  | 'notifications'
  | 'profile'
  | 'purchase'
  | 'raffle'
  | 'pdpGate';

export type PostAuthOptions = {
  action: 'redirect' | 'like' | 'restock';
  legacyProductId?: string;
  onSuccess?: () => void;
  productId?: string;
  productName?: string;
  redirectUrl?: string;
  sizes?: string[];
};

export type FetcherData = {
  completedAction: string;
  data: { action: string };
  email?: string;
  errors?: {
    authentication: boolean;
    conflict: boolean;
    email: boolean;
    message: string;
    mismatch: boolean;
    notFound: boolean;
    password: boolean;
  };
  notifiedProductIds?: number[];
  success?: boolean;
};
